// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"4b47ef39","239":"f21e5f3d","455":"14f58412"}[chunkId] + ".chunk.js";
};